(function () {

  function initCarousel(carousel) {
    if (carousel.dataset.autoStarted === 'true') return;

    const cards = Array.from(
      carousel.querySelectorAll('product-card')
    );

    if (cards.length < 2) return;

    carousel.dataset.autoStarted = 'true';

    let index = 0;
    let timer = null;
    let restartTimer = null;

    function goTo(indexToShow) {
      index = indexToShow % cards.length;

      const carouselRect = carousel.getBoundingClientRect();
      const cardRect = cards[index].getBoundingClientRect();

      carousel.scrollTo({
        left:
          carousel.scrollLeft +
          cardRect.left -
          carouselRect.left,
        behavior: 'smooth'
      });
    }

    function start() {
      clearInterval(timer);

      if (window.innerWidth > 699) return;

      timer = setInterval(function () {
        goTo(index + 1);
      }, 3000);
    }

    function pause() {
      clearInterval(timer);
      clearTimeout(restartTimer);

      restartTimer = setTimeout(start, 5000);
    }

    carousel.addEventListener('touchstart', pause, {
      passive: true
    });

    carousel.addEventListener('pointerdown', pause);

    start();
  }

  function init() {
    document
      .querySelectorAll(
        'scroll-carousel[data-allisit-autoscroll]'
      )
      .forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();